import { useQuery } from "@tanstack/react-query";
import { QueryCacheStats } from "../models/QueryCacheStats";
import { getQueryCacheStats } from "../repositories/query-cache-repository";

// Shared by the usage card and the configuration table. Same query key on purpose: React Query
// hands both of them the one response instead of asking the API twice.
export const useQueryCacheStats = () =>
	useQuery<QueryCacheStats, Error>({
		queryKey: ["queryCacheStats"],
		queryFn: ({ signal }) => getQueryCacheStats(signal),
		refetchInterval: 30000,
		// The app turns refetchOnWindowFocus off globally, which here means coming back from the
		// tab where the data was just loaded showed stale figures with no way to tell. Both
		// overrides are cheap: the sizes are measured when each entry is stored, this only adds
		// them up.
		refetchOnWindowFocus: true,
		refetchIntervalInBackground: true,
	});

// Action names travel with and without brackets and with different casing depending on who wrote
// them, so every comparison between a configured name and a cached one goes through here.
export const normalizeActionName = (actionName?: string | null) =>
	(actionName ?? "").replace(/\[|\]/g, "").trim().toLowerCase();
